export default __webpack_public_path__ + "media/images/image-2-92ef3bb7fb463db3d611cc9922fe4948.jpg";